<template>
  <div id="app">
      <router-view/>
  </div>
</template>

<script>
import './assets/css/iconfont.css';
export default {
  name: 'App',
  mounted(){
  }
}
</script>


<style>

</style>



// WEBPACK FOOTER //
// src/App.vue